import "./rotation.css";
import React from "react";

export default function Rotation(props) {
  const {
    // Pass in overall width/height so we know the SVG size
    dimensions,
    // "clockwise" or "counter-clockwise"
    direction,
    active,
  } = props;
  let numberOfArrows = 2;
  if (direction) {
    numberOfArrows = 20;
  }
  const { width, height } = dimensions;

  // We'll draw the circle in the center of the SVG
  const cx = width / 2;
  const cy = height / 2;
  // Pick a radius that's smaller than the full width/height
  const r = Math.min(width, height) / 2.6;

  // Helper to convert polar coordinates (angle in degrees) to (x, y)
  function polarToCartesian(centerX, centerY, radius, angleDeg) {
    const angleRad = (Math.PI / 180) * angleDeg;
    const x = centerX + radius * Math.cos(angleRad);
    const y = centerY + radius * Math.sin(angleRad);
    return { x, y };
  }

  // Build array of arcs. Each arc covers 360 / numberOfArrows degrees
  const arcs = [];
  const arcAngle = 360 / numberOfArrows;

  for (let i = 0; i < numberOfArrows; i++) {
    const startAngle = i * arcAngle;
    const endAngle = (i + 1) * arcAngle;

    // Start point on the circle
    const { x: startX, y: startY } = polarToCartesian(cx, cy, r, startAngle);
    // End point on the circle
    const { x: endX, y: endY } = polarToCartesian(cx, cy, r, endAngle);

    // Each arc moves from (startX, startY) to (endX, endY)
    // Large-arc-flag = 0 (we only want a small arc, not > 180°),
    // and the swap start and end if we want to go the other way

    const d =
      direction === "clockwise"
        ? [`M ${startX},${startY}`, `A ${r} ${r} 0 0 1 ${endX},${endY}`].join(
            " ",
          )
        : [`M ${endX},${endY}`, `A ${r} ${r} 0 0 0 ${startX},${startY}`].join(
            " ",
          );

    arcs.push(
      <path
        key={`arc-${i}`}
        d={d}
        className={active ? "rotation-active" : "rotation-inactive"}
        // arrowhead at the end of each arc
        markerEnd={direction && "url(#arrowhead)"}
      />,
    );
  }

  return (
    <svg
      width={width}
      height={height}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
        overflow: "visible",
      }}
    >
      <defs>
        <marker
          id="arrowhead"
          markerWidth="15"
          markerHeight="15"
          refX="2"
          refY="3"
          orient="auto"
          markerUnits="strokeWidth"
          className={active ? "arrow-active" : "arrow-inactive"}
        >
          <path d="M-.8,0 L0,6 L4,3 z" />
        </marker>
      </defs>

      {arcs}
    </svg>
  );
}
